import { Component } from '@angular/core';

import { Subject } from 'rxjs';

import { IntervenantsFilters } from '../entities/intervenants-filters.entity';

@Component({
	selector: 'gestion-intervenants',
	templateUrl: 'gestion-intervenants.html',
	// styleUrls: ['gestion-intervenants.css']
})
export class GestionIntervenantsComponent {
	filters$ = new Subject<IntervenantsFilters>();
	
	constructor(
	) {
	}
}